export default {
  "root": "_root_1fp8l_1",
  "item": "_item_1fp8l_1",
  "--animated": "_--animated_1fp8l_1",
  "--bg-neutral": "_--bg-neutral_1fp8l_1",
  "--bg-positive": "_--bg-positive_1fp8l_1",
  "--bg-warning": "_--bg-warning_1fp8l_1",
  "--bg-critical": "_--bg-critical_1fp8l_1",
  "--bg-primary": "_--bg-primary_1fp8l_1",
  "--bg-neutral-faded": "_--bg-neutral-faded_1fp8l_1",
  "--bg-positive-faded": "_--bg-positive-faded_1fp8l_1",
  "--bg-warning-faded": "_--bg-warning-faded_1fp8l_1",
  "--bg-critical-faded": "_--bg-critical-faded_1fp8l_1",
  "--bg-primary-faded": "_--bg-primary-faded_1fp8l_1",
  "--bg-page": "_--bg-page_1fp8l_1",
  "--bg-page-faded": "_--bg-page-faded_1fp8l_1",
  "--bg-disabled": "_--bg-disabled_1fp8l_1",
  "--bg-disabled-faded": "_--bg-disabled-faded_1fp8l_1",
  "--bg-elevation-base": "_--bg-elevation-base_1fp8l_1",
  "--bg-elevation-raised": "_--bg-elevation-raised_1fp8l_1",
  "--bg-elevation-overlay": "_--bg-elevation-overlay_1fp8l_1",
  "--bg-brand": "_--bg-brand_1fp8l_1",
  "--bg-white": "_--bg-white_1fp8l_1",
  "--bg-black": "_--bg-black_1fp8l_1",
  "--shadow-raised": "_--shadow-raised_1fp8l_1",
  "--shadow-overlay": "_--shadow-overlay_1fp8l_1",
  "--overflow-hidden": "_--overflow-hidden_1fp8l_1",
  "--overflow-auto": "_--overflow-auto_1fp8l_1",
  "--divided": "_--divided_1fp8l_1",
  "--flex": "_--flex_1fp8l_1",
  "--direction-column": "_--direction-column_1fp8l_1",
  "item--gap-before": "_item--gap-before_1fp8l_1",
  "item--gap-auto": "_item--gap-auto_1fp8l_1",
  "--direction-column-reverse": "_--direction-column-reverse_1fp8l_1",
  "--direction-row": "_--direction-row_1fp8l_1",
  "--direction-row-reverse": "_--direction-row-reverse_1fp8l_1",
  "--nowrap": "_--nowrap_1fp8l_1",
  "--wrap": "_--wrap_1fp8l_1",
  "--nowrap-false--m": "_--nowrap-false--m_1fp8l_1",
  "--wrap-true--m": "_--wrap-true--m_1fp8l_1",
  "--nowrap-true--m": "_--nowrap-true--m_1fp8l_1",
  "--wrap-false--m": "_--wrap-false--m_1fp8l_1",
  "--nowrap-false--l": "_--nowrap-false--l_1fp8l_1",
  "--wrap-true--l": "_--wrap-true--l_1fp8l_1",
  "--nowrap-true--l": "_--nowrap-true--l_1fp8l_1",
  "--wrap-false--l": "_--wrap-false--l_1fp8l_1",
  "--nowrap-false--xl": "_--nowrap-false--xl_1fp8l_1",
  "--wrap-true--xl": "_--wrap-true--xl_1fp8l_1",
  "--nowrap-true--xl": "_--nowrap-true--xl_1fp8l_1",
  "--wrap-false--xl": "_--wrap-false--xl_1fp8l_1",
  "divider": "_divider_1fp8l_1",
  "item--grow": "_item--grow_1fp8l_1",
  "item--shrink": "_item--shrink_1fp8l_1",
  "item--columns": "_item--columns_1fp8l_1",
  "item--columns-1": "_item--columns-1_1fp8l_1",
  "item--columns-2": "_item--columns-2_1fp8l_1",
  "item--columns-3": "_item--columns-3_1fp8l_1",
  "item--columns-4": "_item--columns-4_1fp8l_1",
  "item--columns-5": "_item--columns-5_1fp8l_1",
  "item--columns-6": "_item--columns-6_1fp8l_1",
  "item--columns-7": "_item--columns-7_1fp8l_1",
  "item--columns-8": "_item--columns-8_1fp8l_1",
  "item--columns-9": "_item--columns-9_1fp8l_1",
  "item--columns-10": "_item--columns-10_1fp8l_1",
  "item--columns-11": "_item--columns-11_1fp8l_1",
  "item--columns-12": "_item--columns-12_1fp8l_1",
  "item--columns-auto": "_item--columns-auto_1fp8l_1",
  "item--columns-1--m": "_item--columns-1--m_1fp8l_1",
  "item--columns-2--m": "_item--columns-2--m_1fp8l_1",
  "item--columns-3--m": "_item--columns-3--m_1fp8l_1",
  "item--columns-4--m": "_item--columns-4--m_1fp8l_1",
  "item--columns-5--m": "_item--columns-5--m_1fp8l_1",
  "item--columns-6--m": "_item--columns-6--m_1fp8l_1",
  "item--columns-7--m": "_item--columns-7--m_1fp8l_1",
  "item--columns-8--m": "_item--columns-8--m_1fp8l_1",
  "item--columns-9--m": "_item--columns-9--m_1fp8l_1",
  "item--columns-10--m": "_item--columns-10--m_1fp8l_1",
  "item--columns-11--m": "_item--columns-11--m_1fp8l_1",
  "item--columns-12--m": "_item--columns-12--m_1fp8l_1",
  "item--columns-auto--m": "_item--columns-auto--m_1fp8l_1",
  "item--columns-1--l": "_item--columns-1--l_1fp8l_1",
  "item--columns-2--l": "_item--columns-2--l_1fp8l_1",
  "item--columns-3--l": "_item--columns-3--l_1fp8l_1",
  "item--columns-4--l": "_item--columns-4--l_1fp8l_1",
  "item--columns-5--l": "_item--columns-5--l_1fp8l_1",
  "item--columns-6--l": "_item--columns-6--l_1fp8l_1",
  "item--columns-7--l": "_item--columns-7--l_1fp8l_1",
  "item--columns-8--l": "_item--columns-8--l_1fp8l_1",
  "item--columns-9--l": "_item--columns-9--l_1fp8l_1",
  "item--columns-10--l": "_item--columns-10--l_1fp8l_1",
  "item--columns-11--l": "_item--columns-11--l_1fp8l_1",
  "item--columns-12--l": "_item--columns-12--l_1fp8l_1",
  "item--columns-auto--l": "_item--columns-auto--l_1fp8l_1",
  "item--columns-1--xl": "_item--columns-1--xl_1fp8l_1",
  "item--columns-2--xl": "_item--columns-2--xl_1fp8l_1",
  "item--columns-3--xl": "_item--columns-3--xl_1fp8l_1",
  "item--columns-4--xl": "_item--columns-4--xl_1fp8l_1",
  "item--columns-5--xl": "_item--columns-5--xl_1fp8l_1",
  "item--columns-6--xl": "_item--columns-6--xl_1fp8l_1",
  "item--columns-7--xl": "_item--columns-7--xl_1fp8l_1",
  "item--columns-8--xl": "_item--columns-8--xl_1fp8l_1",
  "item--columns-9--xl": "_item--columns-9--xl_1fp8l_1",
  "item--columns-10--xl": "_item--columns-10--xl_1fp8l_1",
  "item--columns-11--xl": "_item--columns-11--xl_1fp8l_1",
  "item--columns-12--xl": "_item--columns-12--xl_1fp8l_1",
  "item--columns-auto--xl": "_item--columns-auto--xl_1fp8l_1",
  "--direction-column--m": "_--direction-column--m_1fp8l_1",
  "--direction-column-reverse--m": "_--direction-column-reverse--m_1fp8l_1",
  "--direction-row--m": "_--direction-row--m_1fp8l_1",
  "--direction-row-reverse--m": "_--direction-row-reverse--m_1fp8l_1",
  "item--grow-true--m": "_item--grow-true--m_1fp8l_1",
  "item--grow-false--m": "_item--grow-false--m_1fp8l_1",
  "--direction-column--l": "_--direction-column--l_1fp8l_1",
  "--direction-column-reverse--l": "_--direction-column-reverse--l_1fp8l_1",
  "--direction-row--l": "_--direction-row--l_1fp8l_1",
  "--direction-row-reverse--l": "_--direction-row-reverse--l_1fp8l_1",
  "item--grow-true--l": "_item--grow-true--l_1fp8l_1",
  "item--grow-false--l": "_item--grow-false--l_1fp8l_1",
  "--direction-column--xl": "_--direction-column--xl_1fp8l_1",
  "--direction-column-reverse--xl": "_--direction-column-reverse--xl_1fp8l_1",
  "--direction-row--xl": "_--direction-row--xl_1fp8l_1",
  "--direction-row-reverse--xl": "_--direction-row-reverse--xl_1fp8l_1",
  "item--grow-true--xl": "_item--grow-true--xl_1fp8l_1",
  "item--grow-false--xl": "_item--grow-false--xl_1fp8l_1"
};import "ni:sha-256;q-4GHRsuWA60rXNZtYYVvgSUTHzsCPyhFZP-7KuN9g8";